import React, { useCallback, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Button from '../../components/Button';

const Modals = () => {
  const [show, setShow] = useState(false);

  const handleClose = useCallback(() => setShow(false), []);
  const handleShow = useCallback(() => setShow(true), []);

  return (
    <React.Fragment>
      <Row className="styles-section" id="modals">
        <Col xs={12}>
          <h3>Modals</h3>
        </Col>
        <Col xs={12} sm={6}>
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>Modal heading</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Woohoo, you're reading this text in a modal!
            </Modal.Body>
            <Modal.Footer>
              <Button variant="tertiary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="tertiary" onClick={handleClose}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Col>
        <Col xs={12} sm={6}>
          <Button variant="primary" onClick={handleShow} >
            Open Modal
          </Button>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header>
              <Modal.Title >Modal title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Woohoo, you're reading this text in a modal!
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>Close</Button>
              <Button variant="primary">Save changes</Button>
            </Modal.Footer>
          </Modal>

        </Col>

      </Row>
    </React.Fragment>
  );
};

export default Modals;